import React from 'react';
import PropTypes from 'prop-types';
import { clamp, is } from 'ramda';

import { wrapper, outer, inner } from './Indicator.less';
import smiley from './assets/smiley.png';

const getRadius = severity => clamp(5, 50, 50 * (severity / 6));
const getVASValueRadius = severity => clamp(5, 50, 5 + 45 * (severity / 100));
const getEDSSWidth = severity => `${clamp(0, 100, (severity / 9) * 100)}%`;

const StatusIndicator = ({ severity, title, description }) => (
  <div className={wrapper}>
    {is(Number, severity) && severity > 5 && (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="2.5rem" height="2.2rem">
        <g>
          <circle className={outer} cx="50" cy="50" r="50" strokeWidth="0" />
          <circle
            className={inner}
            cx="50"
            cy="50"
            r={title.indexOf('VASValue') < 0 ? getRadius(severity) : getVASValueRadius(severity)}
            strokeWidth="0"
          />
          <title>{description ? `(${severity}): ${description}` : severity}</title>
        </g>
      </svg>
    )}
    {(!is(Number, severity) || severity <= 5) && <img src={smiley} alt={description} title={description} />}
  </div>
);

export const EDSSIndicator = ({ severity, title, description }) => (
  <div className={wrapper}>
    {is(Number, severity) && (
      <svg xmlns="http://www.w3.org/2000/svg" width="19rem" height="2.2rem">
        <g>
          <rect className={outer} x="0" y="0" width="100%" height="50" strokeWidth="0" />
          <rect className={inner} x="0" y="0" width={getEDSSWidth(severity)} height="50" strokeWidth="0" />
          <title>{`(${severity}): ${description}`}</title>
          <text textAnchor="middle" x="100" y="19" fontSize="20" fill="black">
            {severity}
          </text>
        </g>
      </svg>
    )}
    {!is(Number, severity) && <img src={smiley} alt={description} title={description} />}
  </div>
);

StatusIndicator.propTypes = {
  severity: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
};

EDSSIndicator.propTypes = {
  severity: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default StatusIndicator;
